// src/journey/QuizInJourney.jsx
import React from "react";
import QuizJourneyView from "./QuizJourneyView.js";

function QuizInJourney({ questionsCount = 2, onComplete }) {
    return (
        <QuizJourneyView
            inJourney={true}
            gameLength={questionsCount}
            suppressBackground={true}
            onComplete={onComplete} // ✅ pass down
        />
    );
}

export default QuizInJourney;
